const round = Math.round;

export {round};


// WEBPACK FOOTER //
// ./src/utils/touch2/utils.js